
import { login, logout, loginip } from '@/api/user'
import { getInfo } from '@/api/orgin'
import { getToken, setToken, removeToken, getaccount_type, setaccount_type, getname, setname } from '@/utils/auth'
import router, { resetRouter } from '@/router'
const state = {
  token: getToken(), // 获取token！'http://47.102.147.241'
  name: getname(),
  avatar: '',
  introduction: '',
  roles: [],
  account_type: getaccount_type(),
  baseurl: process.env.VUE_APP_BASE_API // 定义全局baseurl变量http://47.102.105.63
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_ACCOUNTTYPE: (state, account_type) => {
    state.account_type = account_type
  }
}

const actions = {
  // user login
  login({ commit }, userInfo,) {
    const { account_name, account_password, account_type } = userInfo
    return new Promise((resolve, reject) => {
      login({ account_name: account_name, account_password: account_password, account_type: account_type, permissions: 1 }).then(response => {
        const data = {// 把respose里data值赋给token
          token: ''
        }
        data.token = response.data
        commit('SET_TOKEN', data.token)
        commit('SET_NAME', account_name)
        commit('SET_ACCOUNTTYPE', account_type)
        setname(account_name)
        setaccount_type(account_type)
        setToken(data.token)
        console.log(account_name)
        resolve()
        // 调接口把ip打日志上
        loginip({ accountName: userInfo.account_name, loginIp: userInfo.ip }).then(response => {
        })
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
        getInfo().then(response => { // 普通账号
          const { data } = response
          const role = []
          for (let i = 0; i < response.data.length; i++) { // 便利菜单数组提取权限数组
            if (response.data[i].selected) { // 提取页面权限数组
              role.push(response.data[i].menu_key)
            }
            if (response.data[i].listMenuButtons) { // 提取按钮权限数组
              for (let t = 0; t < response.data[i].listMenuButtons.length; t++) {
                if (response.data[i].listMenuButtons[t].selected) {
                  role.push(response.data[i].listMenuButtons[t].menu_button_code)
                }
              }
            }
          }
          if (!data) {
            reject('验证失败，请重新登录.')
          }
          data.roles = role
          const { roles, name, introduction } = data
          console.log(roles)
          // roles must be a non-empty array角色必须是非空数组
          if (!roles || roles.length <= 0) {
            reject('getInfo: 此账号没有分配权限，请分配权限之后再进行登录!')
          }
          commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_INTRODUCTION', introduction)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions动态地修改权限
  changeRoles({ commit, dispatch }, role) {
    return new Promise(async resolve => {
      const token = role + '-token'

      commit('SET_TOKEN', token)
      setToken(token)

      const { roles } = await dispatch('getInfo')

      resetRouter()

      // generate accessible routes map based on roles根据角色生成可访问路由映射
      const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })

      // dynamically add accessible routes
      router.addRoutes(accessRoutes)

      // reset visited views and cached views重置已访问视图和缓存视图
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
